import { FC, useContext, useState } from 'react';
import Card from '../Card/Card';
import common from '../../util/scss/common.module.scss';
import { IconQuestionCircle } from '../../icons/Icons';
import GlobalContext from '../../contexts/GlobalContext';
import styles from './Logout.module.scss';
import useLogoutContext from '../../contexts/LogoutContext';
import { LoadingButton } from '@mui/lab';

const Logout: FC = () => {
    const { language } = useContext(GlobalContext);
    const { logout } = useLogoutContext();
    const [isLoading, setIsLoading] = useState(false);

    const handleLogout = async () => {
        setIsLoading(true);
        await logout();
        setIsLoading(false);
    };

    return (
        <Card>
            <section className={`${common.icon}`} data-testid={'icon-error'}>
                <IconQuestionCircle width={'65'} height={'65'} fillColor={'#696C74'} />
            </section>
            <header>
                <h1 className={common.pageHeader} data-testid="screen-title">
                    {language.logout.confirm.header}
                </h1>
            </header>
            <section className={styles.cta}>
                <LoadingButton
                    className={common.buttonShim}
                    disabled={isLoading ? true : false}
                    loading={isLoading ? true : false}
                    onClick={handleLogout}
                    type="submit"
                    variant="contained"
                    size="large"
                >
                    {language.logout.confirm.cta}
                </LoadingButton>
            </section>
        </Card>
    );
};

export default Logout;
